import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getScoreColor(score) {
  if (score >= 75) return "text-green-400";
  if (score >= 50) return "text-yellow-400";
  return "text-red-400";
}

export function getScoreBgColor(score) {
  if (score >= 75) return "bg-green-500";
  if (score >= 50) return "bg-yellow-500";
  return "bg-red-500";
}

export function getScoreLabel(score) {
  if (score >= 90) return "Excellent";
  if (score >= 75) return "Good";
  if (score >= 60) return "Needs Improvement";
  return "Major Issues";
}

export function getScoreBadgeClass(score) {
  if (score >= 75) return "score-badge-high";
  if (score >= 50) return "score-badge-medium";
  return "score-badge-low";
}

export function formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(date) {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const SECTION_ICONS = {
  discover: "Globe",
  deliver: "Package",
  delight: "HeartHandshake",
  dominate: "Search",
  discourse: "Share2",
  drive: "Megaphone",
};

export const SECTION_COLORS = {
  discover: "#FACC15",
  deliver: "#22C55E",
  delight: "#EC4899",
  dominate: "#3B82F6",
  discourse: "#8B5CF6",
  drive: "#A855F7",
};
